const BASE_MAP = {
    // 个人本地
    '127.0.0.1': 'http://43.129.197.90:8010',
    '192.168.1.28': 'http://43.129.197.90:8010',
    '192.168.30.98': 'http://43.129.197.90:8010',
    // 香港服务器
    'www.guangguangshoping.com': 'https://www.guangguangshoping.com'
}
// 如果是app就直接请求线上链接
const BASE_URL = window.location.hostname ? BASE_MAP[window.location.hostname] : 'https://www.guangguangshoping.com'
export default {
    BASE_URL
}



//////////////////
// WEBPACK FOOTER
// ./static/config/global.js
// module id = 6053
// module chunks = 39